interface CoastFeedNoResultsProps {
  message?: string;
}

export const CoastFeedNoResults = ({ message }: CoastFeedNoResultsProps) => (
  <span>{message || "No results found"}</span>
);
